<template>
  <div class="text-style px-3 py-2">
     <b-form-group 
      :label="hebrew ? 'סגנון טקסט' : 'Text style'" 
      label-class="pb-1"
      >
       <b-form-radio-group
         id="style-radio-group"
         v-model="textStyleValue"
         class="border-top pt-1" 
         stacked
         :options="hebrew ? textStyleOptionsHe : textStyleOptions"
         aria-describedby="Style Analysis Choices"
         name="style-radio-options"
        ></b-form-radio-group>
     </b-form-group>
  </div>
</template>

<script>
export default {
  name: "TextSettings",
  data() {
    return {
      textStyle: 'modern',
      textStyleOptionsHe: [
        { text: 'טקסט מודרני', value: 'modern'},
        { text: 'טקסט קדם-מודרני', value: 'premodern' },
        { text: 'טקסט רבני', value: 'rabbinic' }
      ],
      textStyleOptions: [
        { text: 'Modern text', value: 'modern'},
        { text: 'Pre-modern text', value: 'premodern' },
        { text: 'Rabbinic text', value: 'rabbinic' }
      ],
    }
  },
  computed: {
    hebrew () {
      return this.$settings.hebrew;
    },
    textStyleValue: {
      get () {
        return this.$store.state.textStyle
      },
      set (value) {
        this.$store.commit('SET_TEXT_STYLE',  value)
      }
    }
  }
}
</script>
<style lang="scss">
.text-settings {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  .card-header {
    button {
      font-size: 16px;
      text-align: inherit;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
      height: 28px;
      line-height: 28px;
      &::after {
      //  content: '\f0d8';
        font-family:'Font Awesome 5 Free';
        font-weight: 900;
        position: absolute;
        right: 10px;
        left: auto
      }
      &:hover, &[aria-expanded="true"] {
        background-color: #f6f6f6;
        box-shadow: none;
        color: var(--primary);
      }
      &[aria-expanded="true"] {
        &::after {
        //  content: '\f0d7';
        }
      }
    }
  }
}

.he .card-header button::after {
  left: 10px;
  right: auto;
}
</style>